export const metadata = () => {
  let token = localStorage.getItem('trade.token') || window.electron?.store.get('trade.token');
  return { Authorization: 'Bearer ' + token };
};
